import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {AgreementInfoVo} from '../../common/shared/api/nicolas/vo/AgreementInfoVo.interface';

/**
 * 약관 정보 조회
 *
 * Origin: pageNicolasApi.getAgreements
 * API: POST /auth/v5/getagreement
 */
export async function postAuthGetagreement(
  authParams?: {
    accessToken?: string;
    appUserId?: number;
  },
  options?: FetcherOptions
): Promise<AgreementInfoVo> {
  const isExistedAuthParams =
    authParams && authParams.accessToken && authParams.appUserId;

  const response = await axiosBffFetch(
    '/api/gateway/auth/v5/getagreement',
    {
      method: 'POST',
      data: isExistedAuthParams
        ? {
            app_user_id: authParams.appUserId,
            access_token: authParams.accessToken,
          }
        : undefined,
    },
    options
  );
  return response.data;
}
